<div *ngIf="customWidth" [style.width]="customWidth" class="divider-line"></div>
<div *ngIf="!customWidth" class="divider-line"></div>